import React from 'react';
import { ResetPasswordForm } from 'src/payments/signup/views/reset-password/reset-password-form';
import { useResetPassword } from 'src/payments/signup/views/reset-password/use-password-reset';

type ResetPasswordProps = {
  onClose: () => void;
};

export function ResetPassword(props: ResetPasswordProps): JSX.Element {
  const { resetPassword } = useResetPassword();
  const onCancelResetPassword = (): void => props.onClose();
  const onSubmitResetPassword = async ({ email }: { email: string }): Promise<void> => {
    await resetPassword({ email });
    props.onClose();
  };

  return <ResetPasswordForm onBackClick={onCancelResetPassword} onSubmit={onSubmitResetPassword} />;
}
